import script from "./CreateDatasetTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDatasetTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateDatasetTagDialog.vue?vue&type=style&index=0&id=76fba89c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76fba89c"]])

export default __exports__